module.exports = __webpack_public_path__ + "static/img/Jack_Ziebell_desktop.d4eb454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Ziebell_desktop.jpg
// module id = otpX
// module chunks = 0